import {registerPlugin} from "surveylabJsAssets/chart/charts";
import AbstractChart from "surveylabJsAssets/chart/plugin/abstract-chart";
import {Options} from "highcharts";

export class Bar extends AbstractChart {
    protected allChartOptions(): Options {
        const options: Options = {
            chart: {
                type: 'bar',
                width: 415,
                height: 597,
                marginTop: 27,
                marginBottom: 40
            },
            plotOptions: {
                bar: {
                    pointWidth: 17, // Bar height
                    grouping: false,
                    borderWidth: 0,
                }
            },
            xAxis: {
                labels: {
                    // xAxis is labelled seperatly outside the chart
                    enabled: false,
                },
                tickWidth: 0
            },
            yAxis: {
                min: 20,
                max: 80,
                plotBands: [{
                    color: '#eee',
                    from: 40,
                    to: 60,
                }]
            },
        }

        return super.mergeOptions(super.allChartOptions(), options);
    }
}

// noinspection JSUnusedGlobalSymbols
export default function () {registerPlugin(Bar)}